import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './booking.css';

const Booking = () => {
    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="section sectionBackground" id="booking">
            <div className="viewport">
                <div className="bookingItem">
                    <h1>Termin buchen</h1>
                    <p className="sectionLead">
                        Buchen Sie hier Ihren Termin. Wenn Sie vorab kurz Ihr Anliegen schildern m&ouml;chten,
                        rufen Sie gerne an oder schreiben Sie eine E&#8209;Mail.
                    </p>
                    <p className="bookingNote">
                        Die Buchung erfolgt &uuml;ber Calendly (externer Dienst). Hinweise zur Datenverarbeitung finden Sie in der{' '}
                        <Link to="/privacy">Datenschutzerkl&auml;rung</Link>.
                    </p>
                    <div
                        className="calendly-inline-widget"
                        data-url="https://calendly.com/hploewe?background_color=7f444400"
                        style={{ minWidth: '320px', height: '700px' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default Booking;
